import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import AppStore from '../../assets/images/app_store.png';
import GooglePlay from '../../assets/images/google_play.png';
import MobileApp from '../../assets/images/mobile_app.png';
import { AppButton, AppButtonContainer, AppButtonImage, Container, Image, SubTitle, Title } from './Chat.styled';

export const Chat: FC = () => (
  <>
    <Helmet>
      <title>Hotelspot | Czat</title>
      <meta name="description" content="Hotelspot - czat" />
    </Helmet>
    <Container>
      <Image src={MobileApp} />
      <Title>Aplikacja mobilna</Title>
      <SubTitle>
        Aby skorzystać z czatu, zachęcamy do skorzystania
        z naszej aplikacji mobilnej dostępnej w Play Store oraz App Store
      </SubTitle>
      <AppButtonContainer>
        <AppButton href="https://play.google.com/store/apps/details?id=com.spotstay.hotelspot.mobile.android&pli=1">
          <AppButtonImage src={GooglePlay} />
        </AppButton>
        <AppButton href="https://apps.apple.com/pl/app/hotelspot/id6741736246?l=pl">
          <AppButtonImage src={AppStore} />
        </AppButton>
      </AppButtonContainer>
    </Container>
  </>
);
